import { motion } from "framer-motion";

const HUG_IMG = "/moments/logo.png";

const CHAPTERS = [
  {
    n: "01",
    title: "The Movement",
    body: "Be Kind Community Inc believes kindness is a practice, not a poster. From August 19 to December 19, we move together — one activation a day, some small enough to do before coffee, some big enough to change a block.",
  },
  {
    n: "02",
    title: "One Thousand Bears",
    body: "Every Kindness Bear adopted funds the movement and carries a promise: someone out there needs a hug, and you're sending it. One thousand bears. One thousand reminders that softness is strength.",
  },
  {
    n: "03",
    title: "One Million Pledges",
    body: "A pledge is a line in the sand: I will be the reason someone believes in people today. Sign yours, then live it daily — the calendar is waiting.",
  },
];

export function Manifesto() {
  return (
    <section id="manifesto" className="mx-auto max-w-7xl px-6 py-32 lg:px-12" data-testid="manifesto-section">
      <p className="mb-16 font-mono text-[11px] uppercase tracking-[0.4em] text-[#8A5A0F]">The Manifesto</p>
      <div className="grid gap-24 lg:grid-cols-12">
        <div className="lg:col-span-7">
          {CHAPTERS.map((c, i) => (
            <motion.div
              key={c.n}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.8, delay: i * 0.1 }}
              className={`grid gap-6 border-t border-[#33240E]/15 py-12 sm:grid-cols-12 ${i === 0 ? "border-t-0 pt-0" : ""}`}
              data-testid={`manifesto-chapter-${c.n}`}
            >
              <span className="font-serif text-6xl font-black text-outline sm:col-span-3 lg:text-7xl">{c.n}</span>
              <div className="sm:col-span-9">
                <h2 className="mb-4 font-serif text-3xl font-bold text-[#33240E] lg:text-4xl">{c.title}</h2>
                <p className="max-w-lg text-base font-light leading-relaxed text-muted-foreground">{c.body}</p>
              </div>
            </motion.div>
          ))}
        </div>
        <motion.div
          initial={{ opacity: 0, scale: 0.96 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 1 }}
          className="lg:col-span-5"
        >
          <div className="sticky top-32">
            <div className="overflow-hidden border border-[#33240E]/15 bg-[#FFF9EA]">
              <img src={HUG_IMG} alt="Be Kind Community Inc logo" className="aspect-[4/5] w-full object-contain p-10 transition-transform duration-700 hover:scale-[1.03]" />
            </div>
            <p className="mt-4 font-mono text-[10px] uppercase tracking-[0.3em] text-muted-foreground">Fig. 01 — The name says it all</p>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
